import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isAuthenticated, logout } = useAuth();
  const location = useLocation();

  const handleNavClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/about', label: 'About' },
    { path: '/blog', label: 'Blog' },
    { path: '/docs', label: 'Docs' },
    { path: '/packages', label: 'Package', isButton: true },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-nvidia-dark-800 border-b border-nvidia-green/20 z-50">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center hover:opacity-90 transition-opacity cursor-pointer">
            <img
              src="/images/24CAC708-0BF7-4D67-8C01-DE9CFF0C7EA4 (1).png"
              alt="Orixon Logo"
              data-scroll-reveal="off"
              className="h-12 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={handleNavClick}
                className={`${link.isButton ? 'bg-nvidia-green text-black px-4 py-2 rounded-lg font-semibold hover:bg-opacity-90 ring-0 hover:ring-2 hover:ring-orixon-orange' : isActive(link.path) ? 'text-nvidia-green' : 'text-gray-300 hover:text-orixon-orange'} transition-colors`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-300 hover:text-orixon-orange focus:outline-none"
          >
            {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4">
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => {
                    handleNavClick();
                    setIsOpen(false);
                  }}
                  className={`${link.isButton ? 'bg-nvidia-green text-black px-4 py-2 rounded-lg font-semibold hover:bg-opacity-90 ring-0 hover:ring-2 hover:ring-orixon-orange' : isActive(link.path) ? 'text-nvidia-green' : 'text-gray-300 hover:text-orixon-orange'} transition-colors`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
